import getCurrentSetDataStartWorkoutSelect from '../get-current-set-data'
import { isSetRestSetDataUtil } from '../../../workout-exercise/model/utils'
import getCurrentSetIndexWorkoutExerciseSelect from '../../../workout-exercise/redux/selectors/get-current-set-index'
import { createSelector } from 'reselect'

const getCurrentSetStartWorkoutSelector = createSelector(
  getCurrentSetDataStartWorkoutSelect,
  getCurrentSetIndexWorkoutExerciseSelect,
  (setData, setIndex) => {
    if (!setData) {
      return
    }
    return setData[setIndex]
  }
)

export const isCurrentSetResetStartWorkoutSelector = createSelector(
  getCurrentSetStartWorkoutSelector,
  (currenSet) => isSetRestSetDataUtil(currenSet)
)

export default getCurrentSetStartWorkoutSelector
